import { createSelector } from 'reselect';
import { RootState } from '../store';
import { IUser } from '../../types/User'

const loading = (state: RootState) => state.waterTestStrip.loading;
const error = (state: RootState) => state.waterTestStrip.error;
const success = (state: RootState) => state.waterTestStrip.success;
const getWaterTestStripStatus = (state: RootState) => state.waterTestStrip.status;
const getWaterTestStripJobId = (state: RootState) => state.waterTestStrip.jobData && state.waterTestStrip.jobData._id
const getWaterTestStripJobData = (state: RootState) => state.waterTestStrip.jobData
const getData = (state: RootState) => state.waterTestStrip.data
const getUserData = (state: RootState) => state.waterTestStrip.userData
const getRequestData = (state: RootState) => state.waterTestStrip.requests
const selectWaterTestStripResult = createSelector(
  [getData],
  (data) => {
    if(!data) return null
    return data?.parameters
  }
);


const makeWaterTestStripGroupedResults = createSelector(
  [getData],
  (data):{Good?: number, Low?:number, High?: number, NA?:number, Caution?: number} | null => {
    if(!data) {return null}
    const {parameters } = data as any

    const entries = Object.entries(parameters)
    return entries.reduce((acc, curr)=> {
      const [_,v] = curr

      if(Array.isArray(v)) {v.forEach(item => {
        if(!acc[item.label]){return acc[item.label] =1}
        acc[item.label] += 1
      })}
      return acc
    }, {})

  }
)

export const makeUserCityStateSelector = createSelector(
  [getUserData],
  (userData) => {

    if(!userData || !userData.billing_address) return null
    if(!userData.billing_address.city && !userData.billing_address?.state) return null

    return {city: userData.billing_address.city,state: userData.billing_address.state}
  }
)

const makeWaterTestKitRequestLatest = createSelector(
  [getRequestData],
  (requests) => {

    const sortedValues = requests.slice().sort((a, b) => {
      if (a.createdAt < b.createdAt) return 1;
      if (a.createdAt > b.createdAt) return -1;
      return 0
    })

    return sortedValues[0]
  }
)

export const WaterTestStripSelector = {
  error,
  getData,
  getUserData,
  getWaterTestStripJobData,
  getWaterTestStripJobId,
  getWaterTestStripStatus,
  loading,
  makeUserCityStateSelector,
  makeWaterTestStripGroupedResults,
  selectWaterTestStripResult,
  success,
  getRequestData,
  makeWaterTestKitRequestLatest,
};